import Scans from "./Scans";

export default Scans;
